import React, { useState, useRef, useEffect } from 'react';

import LiveBarWaveformMoving from './LiveBarWaveformMoving';

import {
  Microphone2,
  Briefcase,
  Bank,
  Shield,
  Building,
  Scan,
  Profile,
  InfoCircle,
  ArrowDown2,
  Book1,
  ArrowUp,
  Cardano,
  HuobiToken,
  LampCharge,
  Flash,
  Discover,
  MessageText,
  GlobalSearch,
  Hierarchy2,
  Global,
  Dent,
  Stop,
  PauseCircle,
  BagHappy,
  I3DRotate,
  ArrowUp2,
  CloseCircle,
} from 'iconsax-react';

import starIcon from '../../../../../assets/svgs/IA_BTN.svg';
import stopIcon from '../../../../../assets/svgs/stop.svg';

import { TickCircle } from 'iconsax-react';
import { Tooltip, Whisper } from 'rsuite';
import PromptSelectorButton from './PromptSelectorButton';

type ModelOption = {
  label: string;
  description: string;
  icon: JSX.Element;
};

const modelOptions: ModelOption[] = [
  // {
  //   label: "Harvey",
  //   description: "Repostas robustas, precisas e com alta qualidade e suporta maior número de decisões",
  //   icon: <Discover size="20" className="text-purple-400" />,
  // },
  // {
  //   label: "Web Harvey",
  //   description: "Respostas super inteligentes com base em consultas na Web",
  //   icon: <GlobalSearch size="20" className="text-purple-400" />,
  // },
  {
    label: 'GPTuri 2.0',
    description: 'Ótimo para tarefas complexas que exigem reflexão',
    icon: <HuobiToken size="20" className="text-purple-400" />,
  },
  // {
  //   label: 'Workaholic',
  //   description:
  //     'Raciocínio analítico avançado, ele pensa bastante antes de responder',
  //   icon: <Dent size="22" className="text-purple-400" />,
  // },
  // {
  //   label: "Deep Oracle",
  //   description: "Raciocínio analítico e suporta maior número de decisões",
  //   icon: <Cardano size="22" className="text-purple-400" />,
  // },

  // {
  //   label: "Web Clerk",
  //   description: "Gera respostas com base em consultas na Web",
  //   icon: <Global size="20" className="text-purple-400" />,
  // },
  // {
  //   label: 'GPTuri-mini',
  //   description: 'Equilibra qualidade de resposta e latência',
  //   icon: <LampCharge size="20" className="text-purple-400" />,
  // },
  // {
  //   label: 'Intern',
  //   description: 'Útil para resumos simples',
  //   icon: <Flash size="20" className="text-purple-400" />,
  // },
  // {
  //   label: "Fairy",
  //   description: "Respostas com baixa latência",
  //   icon: <Hierarchy2 size="20" className="text-purple-400" />,
  // },
];

type ModelSelectorParams = {
  modelSelected: ModelOption;
  setModelSelected: React.Dispatch<React.SetStateAction<ModelOption>>;
};

export function ModelSelector({
  modelSelected,
  setModelSelected,
}: ModelSelectorParams) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      {/* Botão principal */}
      <button
        // onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2 bg-purple-50 text-purple-600 rounded-lg border border-transparent hover:bg-purple-100 transition"
      >
        <div
          className="w-5 h-5 bg-purple-500 mask mask-image"
          style={{
            WebkitMaskImage: `url(${starIcon})`,
            maskImage: `url(${starIcon})`,
            maskRepeat: 'no-repeat',
            maskSize: 'contain',
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskSize: 'contain',
          }}
        />

        {modelSelected.label}
        {/* {open ? <ArrowUp2 size="16" /> : <ArrowDown2 size="16" />} */}
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute bottom-full right-0 mb-2 w-96 bg-white border border-solid border-purple-200 rounded-2xl shadow-lg z-50 py-3 px-3">
          {modelOptions.map((option) => (
            <button
              key={option.label}
              onClick={() => {
                setModelSelected(option);
                setOpen(false);
              }}
              className="flex w-full items-center text-left gap-3 p-3 rounded-lg hover:bg-purple-100"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full border bg-[#F4EBFF]">
                {React.cloneElement(option.icon, {
                  size: 18,
                  className: 'text-[#6941C6]',
                })}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-sm text-gray-900">
                  {option.label}
                </div>
                <div className="text-xs text-[#98A2B3] leading-snug">
                  {option.description}
                </div>
              </div>
              {modelSelected.label === option.label && (
                <TickCircle
                  size="18"
                  variant="Bold"
                  className="text-purple-700 mt-1"
                />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

type Option = {
  label: string;
  description: string;
  icon: JSX.Element;
};

const searchOptions: Option[] = [
  {
    label: 'Dinâmica',
    description:
      'GPTuri decide quais dados usar de acordo com a pergunta feita',
    icon: <I3DRotate size="20" className="text-[#475467]" />,
  },
  {
    label: 'Buscar em ementas',
    description: 'Utiliza todas as ementas da coleção para gerar as respostas',
    icon: <MessageText size="20" className="text-[#475467]" />,
  },
  {
    label: 'Busca em inteiros teor relevantes',
    description: 'Utiliza o inteiro teor das 20 melhores para gerar a resposta',
    icon: <Book1 size="20" className="text-[#475467]" />,
  },
  // {
  //   label: 'Busca ampla',
  //   description:
  //     'Utiliza todos os inteiro teores para gerar a resposta. Essa opção pode demorar um pouco',
  //   icon: <BagHappy size="20" className="text-gray-400" />,
  // },
];

type SearchModeSelectorParams = {
  searchSelected: Option;
  setSearchSelected: React.Dispatch<React.SetStateAction<Option>>;
};

export function SearchModeSelector({
  searchSelected,
  setSearchSelected,
}: SearchModeSelectorParams) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      {/* Botão de ativação */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium border border-[#E4E7EC] rounded-lg bg-white text-gray-800 hover:bg-gray-50"
      >
        {/* {searchSelected.label.includes('ementa') ? (
          <MessageText size={18} />
        ) : (
          <Book1 size="18" />
        )} */}

        {React.cloneElement(searchSelected.icon, {
          size: 18,
          color: '#475467',
        })}
        <span className="text-[#101828] text-[14px] font-medium">
          {['Buscar em ementas', 'Busca em inteiros teor relevantes'].includes(
            searchSelected.label,
          )
            ? 'Buscar em'
            : 'Busca'}
        </span>
        <span className="text-blue-600 text-[14px] font-medium">
          {getSearchValue(searchSelected.label)}
        </span>
        {open ? (
          <ArrowUp2 size="16" className="text-blue-600" />
        ) : (
          <ArrowDown2 size="16" className="text-blue-600" />
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute bottom-full right-0 mb-2 w-96 bg-white border border-solid border-gray-200 rounded-xl shadow-lg z-50 py-4 px-3">
          {searchOptions.map((option) => (
            <button
              key={option.label}
              onClick={() => {
                setSearchSelected(option);
                setOpen(false);
              }}
              className="flex w-full items-center text-left gap-3 p-3 rounded-lg hover:bg-gray-100"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full border bg-[#E4E7EC]">
                {React.cloneElement(option.icon, {
                  size: 18,
                  // className: 'text-gray-700',
                })}
              </div>

              <div className="flex-1">
                <div className="font-semibold text-sm text-gray-900">
                  {option.label}
                </div>
                <div className="text-xs text-[#98A2B3] leading-snug">
                  {option.description}
                </div>
              </div>
              {searchSelected.label === option.label && (
                <TickCircle
                  size="18"
                  variant="Bold"
                  className="text-gray-900 mt-1"
                />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const personas = [
  { label: 'Full-Service', icon: <Profile size="16" /> },
  { label: 'Cível', icon: <Scan size="16" /> },
  { label: 'Trabalhista', icon: <Briefcase size="16" /> },
  { label: 'Tributarista', icon: <Bank size="16" /> },
  { label: 'Criminalista', icon: <Shield size="16" /> },
  { label: 'Empresarial', icon: <Building size="16" /> },
];

const getSearchValue = (label: string) => {
  switch (label) {
    case 'Dinâmica':
      return 'dinâmica';
    case 'Buscar em ementas':
      return 'ementa';
    case 'Busca em inteiros teor relevantes':
      return 'inteiro_teor';
    case 'Busca ampla':
      return 'ampla';
    default:
      return 'dinâmica';
  }
};

type ChatInputBarProps = {
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;

  // onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClick: (params: {
    inputText: string;
    persona: string;
    model: string;
    search: string;
  }) => void;
  onStop?: () => void;
  disabled?: boolean;
  onToggleRecording?: () => void;
  isRecording?: boolean;
  setActiveTab: (tab: 'list' | 'create' | 'company') => void;
  setModalOpen: (open: boolean) => void;
  modalOpen: boolean;
  handleInsertPrompt: (promptContent: string) => void;
};

export default function ChatInputBar({
  value,
  onChange,
  onClick,
  onStop,
  onToggleRecording,
  disabled = false,
  setActiveTab,
  setModalOpen,
  modalOpen,
  handleInsertPrompt,
}: ChatInputBarProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const [persona, setPersona] = useState('Full-Service');
  const [personaOpen, setPersonaOpen] = useState(false);
  const personaRef = useRef<HTMLDivElement>(null);
  const [searchSelected, setSearchSelected] = useState(searchOptions[2]);
  const [modelSelected, setModelSelected] = useState(modelOptions[0]);

  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const [audioURL, setAudioURL] = useState<string | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [liveStream, setLiveStream] = useState<MediaStream | null>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const isEnter = e.key === 'Enter';
    const isWithModifier = e.shiftKey || e.ctrlKey;

    if (isEnter && !isWithModifier) {
      e.preventDefault(); // evita quebra de linha
      if (value.trim()) {
        const search = getSearchValue(searchSelected.label);
        const model = modelSelected.label;
        onClick({ inputText: value, persona, model, search });
      }
    }
    // se for Enter com Shift ou Ctrl, permite a quebra de linha
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        personaRef.current &&
        !personaRef.current.contains(event.target as Node)
      ) {
        setPersonaOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    const chunks: Blob[] = [];

    setLiveStream(stream);
    mediaRecorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        chunks.push(e.data);
      }
    };

    mediaRecorder.onstop = () => {
      const blob = new Blob(chunks, { type: 'audio/webm' });
      setAudioBlob(blob);
      setAudioURL(URL.createObjectURL(blob));
      stream.getTracks().forEach((track) => track.stop());
      setLiveStream(null);
    };

    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.start();
    setIsRecording(true);
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
    setLiveStream(null);
  };

  return (
    // <div className="w-full max-w-4xl bg-white border border-gray-200 rounded-2xl p-4 shadow-sm flex flex-col gap-3">
    <div className="mb-4 w-10/12 bg-white border border-solid border-gray-200 rounded-lg p-4 shadow-lg flex flex-col gap-3">
      {isRecording && liveStream && (
        <div className="bg-gray-50 border border-gray-200 rounded-md px-3 py-2 mb-2">
          <LiveBarWaveformMoving
            stream={liveStream}
            isRecording={isRecording}
          />
        </div>
      )}

      {/* Aqui aparece o audioplayer ao vivo se tiver audio gravo e não estiver gravando */}
      {!isRecording && !liveStream && audioURL && (
        <div className="flex items-center gap-3 bg-gray-100 p-2 rounded-xl mb-2">
          <audio controls src={audioURL} className="w-full" />
          <button
            onClick={() => {
              setAudioBlob(null);
              setAudioURL(null);
            }}
            className="text-red-600 text-sm"
          >
            <CloseCircle></CloseCircle>
          </button>
        </div>
      )}

      {!isRecording && !liveStream && (
        <textarea
          ref={textareaRef}
          placeholder="Descreva sua demanda jurídica"
          className="text-[16px] text-gray-700 placeholder-gray-400 px-3 py-2 border border-transparent rounded-md bg-transparent focus:outline-none focus:ring-0 resize-none overflow-hidden"
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          rows={1}
          style={{
            maxHeight: '30vh',
            lineHeight: '1.5',
            overflowY: 'auto', // <- mostra rolagem apenas quando necessário
          }}
        />
      )}

      {/* Linha de ações */}
      <div className="flex justify-between items-center flex-wrap gap-2 relative">
        <div className="flex items-center gap-2 relative">
          <PromptSelectorButton
            onInsertPrompt={(promptContent) => {
              handleInsertPrompt(promptContent);
            }}
            setActiveTab={setActiveTab}
            setModalOpen={setModalOpen}
            modalOpen={modalOpen}
          />

          {/* Persona Dropdown */}

          {/* <SearchModeSelector
            searchSelected={searchSelected}
            setSearchSelected={setSearchSelected}
          ></SearchModeSelector> */}
        </div>

        <div className="flex items-center gap-2">
          <ModelSelector
            modelSelected={modelSelected}
            setModelSelected={setModelSelected}
          ></ModelSelector>
          {/* Microfone */}
          {/* <div className="flex items-center gap-2 p-2">
            <Whisper
              placement="top"
              trigger="hover"
              speaker={<Tooltip>Gravar áudio</Tooltip>}
            >
              <button
                onClick={isRecording ? stopRecording : startRecording}
                className="p-2 rounded-md bg-white border hover:bg-gray-100"
              >
                {isRecording ? (
                  <Stop size="18" color="#EF4444" />
                ) : (
                  <Microphone2 size="18" />
                )}
              </button>
            </Whisper>
          </div> */}

          {/* Enviar */}

          {!isRecording && !liveStream && (
            <button
              onClick={
                disabled
                  ? () => onStop?.()
                  : () => {
                      const search = getSearchValue(searchSelected.label);
                      const model = modelSelected.label;
                      onClick({ inputText: value, persona, model, search });
                    }
              }
              className={`flex gap-2 items-center px-3 py-3 rounded-md transition-colors duration-200 text-sm font-medium ${
                value.trim() || disabled
                  ? 'bg-[#0B1C36] hover:bg-[#132D57] text-white'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              {disabled ? (
                <img src={stopIcon} />
              ) : (
                <ArrowUp size="16" color={value.trim() ? 'white' : '#475467'} />
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
